exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sub-text-label[data-v-f742c968]{font-size:0.85em}.icon-container[data-v-f742c968]{padding-top:5px}.template-name-label[data-v-f742c968]{-ms-word-wrap:break-word;overflow-wrap:break-word;display:block;font-weight:bold}\n", ""]);

